import React, { useState, useEffect } from "react";
// import "../Assests/Scss/SWResults.scss";
import axios from "axios";
import { useSelector } from "react-redux";
import SubHeadersDataTable from "../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";
import {
  exportToExcel,
  // AssessmentName,
} from "../../Student/Reusablecomponents/RegularFunctions";

import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import {
  InstituteGrades,
  ResultsElectiveSubject,
} from "../../ReusableComponents/CommonApis";
import DistrictPerformanceDrillDown from "./TopSection";
import HQAPP from "./SchoolPerformance/PrinciplePerformance";
import axiosInstance from "../../ReusableComponents/Axios";
import { RiFileExcel2Fill } from "react-icons/ri";
const HQStudentwiseR = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const StudenTeacher = JSON.parse(localStorage.getItem("T2S"));
  const HQTP = JSON.parse(localStorage.getItem("NTP"));
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const [Load, SetLoad] = useState(false);

  const [SWRData, SetSWRData] = useState();
  const [TotalData, SeTotalData] = useState();
  const [SelectGrade, SetSelectGrade] = useState(StudenTeacher?.Grade);
  const [RPCount, SetRPCount] = useState();
  const [ElectiveSubjects, SetElectiveSubjects] = useState([]);

  const [OnCHange, SetOnChange] = useState("");

  const GetStudentRegParCount = async (SID) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetStudentRegParCount?ContestCreationId=${
            location.state?.CCID || SelectDate?.value
          }&SchoolId=${
            HQTP?.SchoolId || items.schoolId
          }&AssessmentType=${location.state?.TType || SelectDate?.assessmentType}&Grade=${SelectGrade}&InstituteId=${
            items?.instituteId
          }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        SetRPCount(res.data);
      })
      .catch((err) => {
        SetRPCount();
        console.log(err);
      });
  };

  const GetStudentResponseData = async (SID) => {
    SetSWRData();
    SeTotalData([]);
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetStudentResponseData?ContestCreationId=${
            location.state?.CCID || SelectDate?.value
          }&Class=${SelectGrade}&AssessmentType=${location.state?.TType || SelectDate?.assessmentType}&SchoolId=${
            SID || HQTP?.SchoolId || items.schoolId
          }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        if (res.data[0].studentId) {
          if (SelectGrade >= 11) {
            SeTotalData(res.data);
            GetElectiveSubject(res.data);
            // SetSWRData(res.data);
          } else {
            SetSWRData(res.data);
          }
        } else {
          SetSWRData(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetLoad((prev) => !prev);
        SetSWRData(process.env.REACT_APP_NODATAFOUND_Participated);
      });
  };

  const GetElectiveSubject = async (data) => {
    SetElectiveSubjects([]);
    try {
      const res = await axiosInstance.get(
        `/School/GetElectiveSubjectforAssessment?contestcreationId=${location.state?.CCID || SelectDate?.value}&AssessmentType=${location.state?.TType || SelectDate?.assessmentType}`,
      );
      const OP = res.data
        .filter((ES) => ES.isElective === 1)
        .map((sub) => sub.electiveSubjectName);
      SetElectiveSubjects(OP);
      FilterElectivedata(StudenTeacher?.Subject || OP[0], data);
      // .map((item) => ({
      //   display: item.electiveSubjectName,
      //   value: item.electiveSubjectName,
      // }));
      // props.onChange(OP?.[0]?.display)
      // SetOptions(OP);
    } catch (err) {
      console.log(err);
    }
    // await axios
    //   .get(
    //     process.env.REACT_APP_API_BASE_URL +
    //     `/School/GetSubjectCategoryForGrade?LovCategoryId=67`,
    //     { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    //   )
    //   .then((res) => {
    //     const Subjects = res.data.map((sub) => sub.lovDescription);
    //     SetElectiveSubjects(Subjects);
    //     FilterElectivedata(StudenTeacher?.Subject || Subjects[0], data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
  const [ASSGrade, SetAssGrade] = useState();

  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(
      items?.instituteId,
      {
        value: location.state?.CCID || SelectDate?.value,
        assessmentType: location.state?.TType || SelectDate?.assessmentType,
      },
      USYear?.value,
      HQTP?.UserId || items?.userId,
    );
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(
      Grades?.map((grade) => ({ Name: `Grade ${grade}`, Value: grade })),
    );
    // if (!SelectGrade) {
    //   SetSelectGrade(Grades?.[0]);
    // }
    // else {
    SetSelectGrade(Grades?.includes(SelectGrade) ? SelectGrade : Grades?.[0]);
    // }
  };
  useEffect(() => {
    if (SelectGrade) {
      GetStudentResponseData(OnCHange?.SchoolId);
      GetStudentRegParCount(OnCHange?.SchoolId);
    }
    GetAssmentdates();
  }, [SelectGrade, SelectDate, OnCHange]);

  const FilterElectivedata = (Sub, data) => {
    SetLoad((prev) => !prev);
    const Filter = data?.filter((item) => item.subject3Name === Sub);
    if (Filter?.length > 0) {
      SetSWRData(Filter);
    } else {
      SetSWRData(process.env.REACT_APP_NODATAFOUND_Participated);
    }
    SetLoad((prev) => !prev);
  };
  const OpenPerformanceReport = (row) => {
    const TS = {
      Studentid: row.userId,
      Grade: SelectGrade,
      StudentName: row.studentName,
      StudentRollno: row.studentId,
      mediumOfInstruction: row.mediumOfInstruction,
      MediumName: row.mediumOfInstructionVal,
      AssessmentTypeName: SelectDate?.assessmentTypeName,
      CCID: SelectDate?.value,
      TesType: SelectDate?.assessmentType,
      Grade: SelectGrade,
      Subjects: [
        row?.subject1Name,
        row?.subject2Name,
        row?.subject3Name,
        row?.subject4Name,
      ]
        .filter((x) => x)
        .join(","),
    };
    localStorage.setItem("T2S", JSON.stringify(TS));
    if (location.state?.TType === 3) {
      navigate(`/Performance/Samagra/LoPerformance`, {
        state: {
          userId: row.userId,
          CCID: location.state?.CCID || SelectDate?.value,
          TType: location.state?.TType || SelectDate?.assessmentType,
          Grade: SelectGrade,
          Medium: row.mediumOfInstruction,
          Date: location.state?.AssessmentDate,
        },
      });
    } else {
      window.open("/Performance/LoPerformanceReport", "_blank");
      // navigate(`/Performance/LoPerformanceReport`, {
      //   state: {
      //     CCID: location.state?.CCID || SelectDate?.value, TType: location.state?.TType || SelectDate?.assessmentType, Grade: SelectGrade
      //     , Subjects: [row?.subject1Name, row?.subject2Name, row?.subject3Name].join(",")
      //   }
      // });
    }
  };
  const [SDetailes, SetSDetails] = useState(false);
  const OpenViewAnswerSheet = (row) => {
    SetSDetails(row);
    const TS = {
      Studentid: row.userId,
      Grade: SelectGrade,
      StudentName: row.studentName,
      StudentRollno: row.studentId,
      mediumOfInstruction: row.mediumOfInstruction,
      MediumName: row.mediumOfInstructionVal,
      AssessmentTypeName: SelectDate?.assessmentTypeName,
      CCID: SelectDate?.value,
      TesType: SelectDate?.assessmentType,
      Grade: SelectGrade,
      Subjects:
        SelectDate?.assessmentType !== 3
          ? [
              row?.subject1Name,
              row?.subject2Name,
              row?.subject3Name,
              row?.subject4Name,
            ]
              .filter((x) => x)
              .join(",")
          : SWRData?.[0]?.totalSubjects,
    };
    localStorage.setItem("T2S", JSON.stringify(TS));
    window.open(
      "/Performance/ViewAnswerSheetDetails/ViewAnswerSheet",
      "_blank",
    );
    // navigate(`/Performance/ViewAnswerSheetDetails/ViewAnswerSheet`, {
    //   state: {
    //     CCID: location.state?.CCID || SelectDate?.value, TType: location.state?.TType || SelectDate?.assessmentType, Grade: SelectGrade
    //     , Subjects: location.state?.TType !== 3 ? [row?.subject1Name, row?.subject2Name, row?.subject3Name].join(",") : SWRData?.[0]?.totalSubjects
    //   }
    // });
  };
  const DownloadSWR = (Data) => {
    const subjectCount =
      location.state?.TType === 3
        ? SWRData?.[0]?.TotalSubScore?.split(",").length || 2
        : SelectGrade < 11 &&
            SWRData?.[0].totalSubjects?.split(",").length === 3
          ? 3
          : SelectGrade < 11
            ? 4
            : 3;
    const XL = Data?.map((item, index) => {
      const row = {
        SNo: index + 1,
        "Student ID": item.studentId,
        Student: item.studentName,
      };

      // Dynamically add subject columns
      for (let i = 1; i <= subjectCount; i++) {
        const subName = SWRData?.[0]?.[`subject${i}Name`];
        row[`${subName} Score`] = item[`subject${i}Score`];
        row[`${subName} %`] = `${item[`subject${i}Percentage`]} %`;
      }
      row["Total Score"] = item.totalScore;
      row["Total %"] = item.totalPercentage;
      return row;
    });
    exportToExcel(
      XL,
      `Student Subject Wise Result - ${SelectDate?.examStartDate}`,
      false,
      "Subject Wise Result",
    );
  };

  const SelectESubject = (e) => {
    localStorage.removeItem("T2S");
    FilterElectivedata(e.target.value, TotalData);
  };

  const SUbHeadercolumns = [
    { name: "Student Id", selector: "studentId", sortable: true },
    {
      name: "Student Name",
      selector: "studentName",
      sortable: true,
      cell: (row) => (
        <div style={{ textAlign: "justify" }}>{row.studentName}</div>
      ),
      Hcell: (row) => <div style={{ textAlign: "justify" }}>{row.name}</div>,
    },
    {
      name: "Medium",
      selector: "mediumOfInstructionVal",
      sortable: true,
    },

    ...(SWRData?.[0]
      ? [
          ...Array(
            location.state?.TType === 3
              ? SWRData?.[0]?.TotalSubScore?.split(",").length || 2
              : 3,
          ),
        ].map((_, i) => ({
          name: SWRData[0][`subject${i + 1}Name`],
          subColumns: [
            { name: "Score", selector: `subject${i + 1}Score`, sortable: true },
            {
              name: "%",
              selector: `subject${i + 1}Percentage`,
              sortable: true,
              cell: (row) => `${row[`subject${i + 1}Percentage`]}%`,
            },
          ],
        }))
      : []),
    {
      name: "Total",
      subColumns: [
        { name: "Score", selector: "totalScore", sortable: true },
        {
          name: "%",
          selector: "totalPercentage",
          sortable: true,
          cell: (row) => `${row.totalPercentage}%`,
        },
      ],
    },
    {
      name: "View Answer sheet",
      cell: (row) => (
        <div
          className="CPointer"
          onClick={() => OpenViewAnswerSheet(row)}
          title="View Answer sheet"
        >
          <FaRegEye />{" "}
        </div>
      ),
    },
    {
      name: "LO Performance",
      cell: (row) => (
        <div
          onClick={() => OpenPerformanceReport(row)}
          className="CPointer"
          title="View LO Performance"
        >
          <FaRegEye />
        </div>
      ),
    },
  ];

  const getColumns = (data) => {
    if (!data || data.length === 0) return [];

    const subjectCount =
      location.state?.TType === 3
        ? data[0]?.TotalSubScore?.split(",").length || 2
        : SelectGrade < 11
          ? 4
          : 3;

    return [
      { name: "Student Id", selector: "studentId", sortable: true },

      {
        name: "Student Name",
        selector: "studentName",
        sortable: true,
        cell: (row) => (
          <div style={{ textAlign: "justify" }}>{row.studentName}</div>
        ),
      },

      { name: "Medium", selector: "mediumOfInstructionVal", sortable: true },

      // ✅ SUBJECT HEADERS FROM THIS DATASET
      ...Array.from({ length: subjectCount }, (_, i) => ({
        name: data[0][`subject${i + 1}Name`],
        subColumns: [
          { name: "Score", selector: `subject${i + 1}Score`, sortable: true },
          {
            name: "%",
            selector: `subject${i + 1}Percentage`,
            sortable: true,
            cell: (row) => `${row[`subject${i + 1}Percentage`]}%`,
          },
        ],
      })),

      {
        name: "Total",
        subColumns: [
          { name: "Score", selector: "totalScore", sortable: true },
          {
            name: "%",
            selector: "totalPercentage",
            sortable: true,
            cell: (row) => `${row.totalPercentage}%`,
          },
        ],
      },
      {
        name: "View Answer sheet",
        cell: (row) => (
          <div
            className="CPointer"
            onClick={() => OpenViewAnswerSheet(row)}
            title="View Answer sheet"
          >
            <FaRegEye />{" "}
          </div>
        ),
      },
      {
        name: "LO Performance",
        cell: (row) => (
          <div
            onClick={() => OpenPerformanceReport(row)}
            className="CPointer"
            title="View LO Performance"
          >
            <FaRegEye />{" "}
          </div>
        ),
      },
    ];
  };

  const AssessmentDeatils = (Data) => {
    const subjectCount =
      location.state?.TType === 3
        ? Data?.[0]?.TotalSubScore?.split(",").length || 2
        : SelectGrade < 11 &&
            SWRData?.[0].totalSubjects?.split(",").length === 3
          ? 3
          : SelectGrade < 11
            ? 4
            : 3;
    const subjects = Array.from({ length: subjectCount }, (_, i) => ({
      name:
        Data?.[0]?.[`subject${i + 1}Name`] ||
        TotalData?.[0]?.[`subject${i + 1}Name`],
      count: Number(
        Data?.[0]?.[`subject${i + 1}QCount`] ||
          TotalData?.[0]?.[`subject${i + 1}QCount`] ||
          0,
      ),
    }));
    const total = subjects.reduce((sum, s) => sum + s.count, 0);
    const MC = subjects.reduce((sum, s) => sum + s.count, 0) * 2;
    return (
      <div className="dflex gap-1">
        <div className="dflex gap-1">
          <b>Total Questions : </b>
          {total} {""}(
          {subjects.map((s, i) => (
            <span key={i}>
              {s.name}-{s.count}
              {i !== subjects.length - 1 && ","}
            </span>
          ))}
          ){" "}
        </div>{" "}
        |
        <div className="dflex gap-1">
          {" "}
          <b>Max Credits :</b> {MC}{" "}
        </div>
      </div>
    );
  };
  const NavigateReportcard = () => {
    navigate("/Performance/Reportcards", {
      state: { SchoolId: HQTP?.SchoolId, SchoolName: HQTP?.SchoolName },
    });
  };
  return (
    <div className="TeacherBgImage ">
      <InternetChecking />
      <DistrictPerformanceDrillDown
        selectSchool={HQTP?.SchoolName}
        SelectSchoolId={HQTP?.SchoolId}
        HitApi={SetOnChange}
        Store={SDetailes}
      />
      <div className="Card p-3 mt-3">
        <div className="dflex JSBetween alignitems">
          <button className="Buttons" onClick={() => NavigateReportcard()}>
            View Report Card
          </button>
          <div className="MainHeading">
            {HQTP?.SchoolName} School Performance
          </div>
          <div></div>
        </div>
        <hr />
        <HQAPP SSchoolId={HQTP?.SchoolId} HQUserid={HQTP?.UserId} />
        <div className="mt-3"></div>
        <TabViewValues
          Tabs={ASSGrade}
          Selectedtab={SelectGrade}
          onClick={(e) => SetSelectGrade(e)}
        />

        <div
          className="SWRDetails dflex mt-2 JSBetween alignitems"
          style={{ fontSize: "15px" }}
        >
          <div className="dflex gap-1">
            {(SWRData?.[0].studentId || TotalData?.[0]?.studentId) && (
              <>
                <div className="dflex gap-1">
                  {" "}
                  <b>Registered :</b>
                  {RPCount?.[0]?.studentRegistered}{" "}
                </div>{" "}
                |
                <div className="dflex gap-1">
                  <b>Participated :</b>
                  {RPCount?.[0]?.studentParticipation}
                  {SelectGrade >= 11 && (
                    <>
                      (
                      {ElectiveSubjects?.map((subject) => ({
                        subject,
                        count:
                          TotalData?.filter(
                            (item) => item.subject3Name === subject,
                          ).length || 0,
                      }))
                        .filter((item) => item.count > 0)
                        .map((item, index, arr) => (
                          <span key={index}>
                            {item.subject}-{item.count}
                            {index !== arr.length - 1 && ", "}
                          </span>
                        ))}
                      )
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div>
            {SWRData?.[0].studentId &&
              SelectGrade < 11 &&
              SWRData?.[0].totalSubjects?.split(",").length === 3 && (
                <>
                  {AssessmentDeatils(SWRData)}
                  <div
                    className="ExportExcel"
                    onClick={() => DownloadSWR(SWRData)}
                  >
                    {" "}
                    <RiFileExcel2Fill /> Export{" "}
                  </div>{" "}
                </>
              )}
          </div>
        </div>

        {SelectGrade < 11 &&
        SWRData?.[0].totalSubjects?.split(",").length === 3 ? (
          <div className="Card">
            {SWRData?.[0].studentId ? (
              <SubHeadersDataTable
                DisplaySearch={true}
                ShowPagination={true}
                Dropdownvalues={[10, 25, 50, 100]}
                data={SWRData}
                ShowPagecount={true}
                columns={SUbHeadercolumns}
                className="NCLDataTable"
              />
            ) : (
              <div className="ErrorMessage ">{SWRData}</div>
            )}
          </div>
        ) : (
          <>
            {(
              SelectGrade >= 11 ? TotalData?.length > 0 : SWRData?.[0].studentId
            ) ? (
              (SelectGrade >= 11
                ? ElectiveSubjects
                : items?.languageSubjectName?.split(",")
              ).map((subject, index) => {
                const subjectData =
                  SelectGrade >= 11
                    ? TotalData.filter((item) => item.subject3Name === subject)
                    : SWRData.filter(
                        (item) => item.subject4Name === subject.trim(),
                      );
                return subjectData.length > 0 ? (
                  <div key={index} className="mb-3 mt-2">
                    <div className="dflex JSBetween alignitems">
                      {" "}
                      <h6> Subject: {subject}</h6>
                      <div className="dflex gap-3 alignitems">
                        {AssessmentDeatils(subjectData)}{" "}
                        <div
                          className="ExportExcel"
                          onClick={() => DownloadSWR(subjectData)}
                        >
                          {" "}
                          <RiFileExcel2Fill /> Export{" "}
                        </div>
                      </div>
                    </div>
                    <SubHeadersDataTable
                      DisplaySearch={true}
                      ShowPagination={true}
                      Dropdownvalues={[10, 25, 50, 100]}
                      data={subjectData}
                      ShowPagecount={true}
                      columns={getColumns(subjectData)}
                      className="NCLDataTable Card"
                    />
                  </div>
                ) : (
                  ""
                );
              })
            ) : (
              <div className="Card ErrorMessage ">
                {process.env.REACT_APP_NODATAFOUND_Participated}
              </div>
            )}
          </>
        )}
      </div>
      {Load && <Loading />}
    </div>
  );
};
export default HQStudentwiseR;
